import type {ReactElement} from 'react';
import {QRField} from '@Components/qr-code-generator/components/qr-field/qr-field';
import {QRPayloadField, QRWifiSecurity} from '@Libraries/qr-code/qr-code.types';
import {getWifiSecurityLabel} from '@Components/qr-code-generator/qr-code-generator.library';
import {RadioButton} from '@Components/radio-button';
import type {RadioButtonOption} from '@Components/radio-button/radio-button';
import {Text, TextSize} from '@Components/text';
import type {QRWifiFormProps} from './qr-wifi-form.types';
import {QR_WIFI_SECURITY_BY_ID, QR_WIFI_SECURITY_ORDER} from './qr-wifi-form.types';

export function QRWifiForm({input, issues, onPatch}: QRWifiFormProps): ReactElement {
  const securityOptions: RadioButtonOption[] = QR_WIFI_SECURITY_ORDER.map((security) => {
    return {id: security, text: getWifiSecurityLabel(security)};
  });

  const renderPasswordField = (): ReactElement | null => {
    if (input.security === QRWifiSecurity.NONE) {
      return null;
    }
    return (
      <QRField
        label={window.i18next.t('pmwjs_qr_generator_wifi_password_label')}
        placeholder={window.i18next.t('pmwjs_qr_generator_wifi_password_placeholder')}
        value={input.password}
        field={QRPayloadField.PASSWORD}
        issues={issues}
        onValueChange={(password): void => {
          onPatch({password});
        }}
      />
    );
  };

  return (
    <>
      <QRField
        label={window.i18next.t('pmwjs_qr_generator_wifi_ssid_label')}
        placeholder={window.i18next.t('pmwjs_qr_generator_wifi_ssid_placeholder')}
        value={input.ssid}
        field={QRPayloadField.SSID}
        issues={issues}
        onValueChange={(ssid): void => {
          onPatch({ssid});
        }}
      />
      <div>
        <Text val={window.i18next.t('pmwjs_qr_generator_wifi_security_label')} size={TextSize.MD} bold />
        <RadioButton
          options={securityOptions}
          selectionId={input.security}
          onSelectionCallback={(selectedId): void => {
            onPatch({security: QR_WIFI_SECURITY_BY_ID[selectedId] ?? QRWifiSecurity.WPA});
          }}
        />
      </div>
      {renderPasswordField()}
    </>
  );
}
